<script>
  /* Executable code section of the program */
  //Tools importation
  import { getResetPassword } from "../../apis/APIS";
  import { alertMessagge, isAlertOn } from "../../apis/storage";
  import AlertModal from "../../components/Modals/AlertModal.svelte";

  let email = ""

    //function to display alert
    const displayAlert = () => {
    $isAlertOn = true;
  };
  //Function to reset password
  const reset = () => {
    getResetPassword(email)
        .then(() => {
          $alertMessagge = "A link has been sent to your registered email to reset your password.";
          displayAlert();
        })
        .catch(() => {
          $alertMessagge = "Please enter a valid email to send the recovery email.";
          displayAlert();
        });
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="content">
    <div class="tittle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        fill="currentColor"
        class="bi bi-person-fill-lock"
        viewBox="0 0 16 16"
      >
        <path
          d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5v-1a2 2 0 0 1 .01-.2 4.49 4.49 0 0 1 1.534-3.693Q8.844 9.002 8 9c-5 0-6 3-6 4m7 0a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"
        />
      </svg>
      <h2>Reset Password</h2>
    </div>
    <div class="contentContainer">
      <p>
        Enter your email address and we will send you instructions for a new password
      </p>
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="floatingPassword"
          placeholder="Contraseña"
          bind:value={email}
        />
        <label for="floatingPassword">Email</label>
        <br />
      </div>
    </div>
    <div class="button">
      <button class="btnInformation" on:click={reset}> Send Email </button>
    </div>
  </div>
</section>
{#if $isAlertOn}
  <AlertModal/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */

  .principalContainer {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background-color: white;
  }
  .tittle {
    display: flex;
    align-items: center;
  }
  h2 {
    padding-top: 5px;
  }
  .content {
    width: 35%;
    height: 45%;
    background-color: white;
    border-radius: 12px;
    padding: 20px 40px;
  }
  .contentContainer {
    width: 100%;
  }
  .contentContainer > p {
    opacity: 0.8;
  }
  .button {
    display: flex;
    justify-content: center;
  }
  .btnInformation {
    padding: 10px;
    border: 0;
    color: white;
    width: 300px;
    border-radius: 12px;
    font-size: 20px;
    background-color: #ed2824;
  }
  .btnInformation:hover {
    background-color: #ff4d44;
    transition: ease-in-out 0.5s;
  }
  /* /////////Tabletas///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .contentContainer {
      width: 100%;
      padding: 40px;
    }
    .content {
      margin-top: 20px;
      width: 60%;
      height: 30%;
    }
  }
  /* /////////Phones ///////// */
  @media (max-width: 700px) {
    .principalContainer {
      display: flex;
      align-items: center;
    }
    .contentContainer {
      width: 100%;
    }
    .content {
      width: 100%;
      height: 40%;
    }
  }
  </style>